import * as CONSTANT from "../../../../utils/actionTypes";
import UNIVERSAL from "../../../../utils/config";
import { setLoader, unsetLoader } from "../../../../store/actions/loaderActions";
import { set_snack_bar } from "../../../../store/actions/snackbarActions";
import "firebase/storage";

export function viewAllBadReview(
    token,
    user_id,
    searchInput,
    page,
    pageSize,
    startDate,
    endDate,
    selectedStatus
) {
    return (dispatch) => {
        dispatch(setLoader());
        return fetch(UNIVERSAL.BASEURL + "feedback/view", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                token,
            },
            body: JSON.stringify({
                admin_id: user_id,
                searchInput,
                page: parseInt(page),
                pageSize,
                startDate,
                endDate,
                selectedStatus,
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {

                if (
                    responseJson.statusCode === 200 ||
                    responseJson.statusCode === 201
                ) {
                    dispatch({
                        type: CONSTANT.BADFEEDBACK,
                        payload: responseJson.data.data,
                        count: responseJson.data.totalfeedbacks,
                    });
                    dispatch(unsetLoader());
                    dispatch(set_snack_bar(responseJson.status, responseJson.message));
                } else if (
                    responseJson.statusCode === 401 ||
                    responseJson.statusCode === 404
                ) {
                    dispatch({ type: CONSTANT.BADFEEDBACK, payload: [], count: 0 });
                    dispatch(set_snack_bar(responseJson.status, responseJson.message));
                    dispatch(unsetLoader());
                } else {
                    dispatch(set_snack_bar(true, responseJson.message || "An error occurred"));
                    dispatch(unsetLoader());
                }
            })
            .catch((error) => {
                dispatch(unsetLoader());
                dispatch(set_snack_bar(true, "Check Your Internet Connection"));
                console.error(error);
            });
    };
}